import { render } from "./ClientLogos.vue?vue&type=template&id=ed620c48"
import script from "./ClientLogos.vue?vue&type=script&lang=js"
export * from "./ClientLogos.vue?vue&type=script&lang=js"

import exportComponent from "/Users/michaelbrumm/Local Sites/allis-studio-v2/app/public/wp-content/themes/allisstudio-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__